export default "__VITE_ASSET__fc2a0c84__"